export var Variants;
(function (Variants) {
    Variants["primary"] = "primary";
    Variants["gradient"] = "gradient";
})(Variants || (Variants = {}));
export var Sizes;
(function (Sizes) {
    Sizes["thin"] = "thin";
    Sizes["heavy"] = "heavy";
})(Sizes || (Sizes = {}));
//# sourceMappingURL=constants.js.map